// extracted by mini-css-extract-plugin
export var bioImage = "conference-module--bioImage--83a7c";
export var overviewText = "conference-module--overviewText--fddc0";
export var overviewTextWrap = "conference-module--overviewTextWrap--3ee40";
export var primaryItem = "conference-module--primaryItem--6896d";
export var primaryStaff = "conference-module--primaryStaff--5ea6f";
export var sectionHeading = "conference-module--sectionHeading--629ce";
export var sectionInset = "conference-module--sectionInset--b01ff";
export var sectionItem = "conference-module--sectionItem--72b5c";
export var slideUp = "conference-module--slideUp--e1814";
export var slideUpLarge = "conference-module--slideUpLarge--004ab";
export var socialWrap = "conference-module--socialWrap--91c73";
export var speakersContainer = "conference-module--speakersContainer--ffc8f";
export var speakersHeader = "conference-module--speakersHeader--2e264";
export var speakersInnerContainer = "conference-module--speakersInnerContainer--d9439";
export var speakersTitle = "conference-module--speakersTitle--b7e3c";
export var speakersWrap = "conference-module--speakersWrap--360e2";
export var sponsorItem = "conference-module--sponsorItem--0e03f";
export var sponsorLogo = "conference-module--sponsorLogo--77582";
export var sponsorsSection = "conference-module--sponsorsSection--be312";
export var staffName = "conference-module--staffName--61d4b";
export var staffPosition = "conference-module--staffPosition--5dc8b";